export type EmptyLocation = {
  id: number
  shipment: string
  city: string
  state: string
  availabilityDate: Date
  zipcode?: string
  timezone?: string
}

export function isDateBeforePickupTime(date: Date, pickupTime: Date) {
  return date.valueOf() >= pickupTime.valueOf()
}
